import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import Spinner from '@/components/ui/Spinner';

/**
 * AuthGuard wraps protected route groups.
 * Usage: <Route element={<AuthGuard />}> ... child routes ... </Route>
 *
 * - While session is being validated: shows a centered loading spinner.
 * - If not authenticated: redirects to /login.
 * - If authenticated: renders the nested routes via <Outlet />.
 */
export default function AuthGuard() {
  const { isLoading, isAuthenticated } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-dark-base">
        <Spinner size="lg" label="Loading..." />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <Outlet />;
}
